import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useBookData } from '../data/books';
import { SOCIAL_LINKS } from '../components/Layout';
import HomeArt from '../components/HomeArt';

const Home = () => {
  const { currentlyReading } = useBookData();
  // The map picks a random city on every load; /?city=<slug> pins one for previewing.
  const [params] = useSearchParams();
  const city = params.get('city') || undefined;

  return (
    <div className="page">
      <section className="home-hero">
        <div className="home-hero-text">
          <h1 className="page-title">Hi, I'm Vamsi.</h1>
          <p>
            I'm the cofounder and CTO of{' '}
            <a
              href="https://www.trycontour.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-link"
            >
              Contour (YC S23)
            </a>
            . I enjoy reading, coding, chess, and make questionable bets on football and basketball.
          </p>
          <p>
            Chat with me about Contour{' '}
            <a href="mailto:vamsi@trycontour.com" className="text-link">
              over email
            </a>
            , or{' '}
            <a
              href="https://cal.com/vamsi-saladi/30min"
              target="_blank"
              rel="noopener noreferrer"
              className="text-link"
            >
              book a meeting
            </a>
            .
          </p>
        </div>
        <div className="home-hero-art">
          <HomeArt city={city} />
        </div>
      </section>

      <section className="home-now" aria-label="Right now">
        <div>
          <h2>
            <span className="now-dot" aria-hidden="true" />
            Reading now
          </h2>
          <ul className="home-reading">
            {currentlyReading.map((book) => (
              <li key={book.goodreadsUrl || book.title}>
                <Link to="/bookshelf">
                  <img src={book.coverImage} alt="" />
                  <span>
                    <span className="home-reading-title">{book.title}</span>
                    <br />
                    <span className="home-reading-meta">
                      {book.author}
                      {typeof book.progress === 'number' ? `, ${book.progress}% in` : ''}
                    </span>
                  </span>
                </Link>
              </li>
            ))}
          </ul>
          <p className="home-reading-all">
            <Link to="/bookshelf" className="text-link">
              See the whole bookshelf
            </Link>
          </p>
        </div>

        <div>
          <h2>Elsewhere</h2>
          <ul className="home-links">
            {SOCIAL_LINKS.map(({ label, href, Icon }) => (
              <li key={label}>
                <a href={href} target="_blank" rel="noopener noreferrer">
                  <Icon size={16} aria-hidden="true" />
                  <span>{label}</span>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </div>
  );
};

export default Home;
